<template>
    <div class='cleopatra-tickets'>
        <div v-for="(item, index) in scenarioAfterChanges" :key="index" :class="[{'d-flex align-items-center':true}, {'itemBorder':index != 5}]">
            <div v-for="(symbol, symbolIndex) in item.symbols" :key="symbolIndex" class='col-2 text-center p-0 pb-2 item'> 
                <img :class="item.lucky || ['scroll', 'urn'].includes(symbol)  ? 'lucky' : 'unlucky'" :src="`/fg/v2/games/cleopatra/img/symbols/${symbol}.png`">
            </div>
            <div class='col-2 text-center p-0 pb-2 item multiplier'>
                x{{item.multiplier}}
            </div>
            <div :class="[{'text-success' : item.lucky}, {'col-3 text-center p-0':true}]">{{item.amount | currency}}</div>
        </div>

        <div v-if="ticket.scenario.bonus_2 && ticket.scenario.bonus_2.picks" class = "text-center mt-2">
            <h6>{{'bonus' | lang}}</h6>
            <div class="d-flex flex-wrap">
                <div v-for="(item, index) in ticket.scenario.bonus_2.picks" :key="index" :class="[{'text-success' : item.lucky}, {'pb-2 col-4 text-center':true}]">{{ item.amount | currency }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        methods: {
            getChangedSymbol() {
                
            }
        },
        computed: {
            scenarioAfterChanges() {
                if(Object.entries(this.ticket.scenario.bonus_1).length) {
                    for (const [key, bonus] of Object.entries(this.ticket.scenario.bonus_1)) {
                        this.ticket.scenario.items[bonus['index']]['symbols'][bonus['symbol_index']] = bonus['symbol'];
                    }
                }

                return this.ticket.scenario.items;
            }
        }
    }
</script>

<style>
    .cleopatra-tickets .itemBorder {
         border-bottom: 1px solid #5d646b;
    }

    .cleopatra-tickets img.unlucky {
        filter: grayscale(100%);
    }

    .cleopatra-tickets img.lucky, .cleopatra-tickets img.unlucky {
        width: 80%;
    }
    .cleopatra-tickets .multiplier {
        color: #fff;
        font-size: 24px;
        -webkit-text-stroke: 1px #DEB35C;
        font-family: cambria;
    }
</style>